var _rect, _path, _path2, _path3, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrototyping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 5,
    fill: "#F89C1C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4409 18.9274L31.1392 15.2299C29.9209 14.6916 28.0792 14.6916 26.8609 15.2299L18.5592 18.9274C16.4625 19.8624 16.1509 21.1374 16.1509 21.8174C16.1509 22.4974 16.4625 23.7724 18.5592 24.7074L26.8609 28.4049C27.47 28.6741 28.235 28.8158 29 28.8158C29.765 28.8158 30.53 28.6741 31.1392 28.4049L39.4409 24.7074C41.5375 23.7724 41.8492 22.4974 41.8492 21.8174C41.8492 21.1374 41.5517 19.8624 39.4409 18.9274Z",
    fill: "url(#paint0_linear_1403_2784)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29 36.1399C28.4616 36.1399 27.9233 36.0266 27.4275 35.8141L17.8791 31.5641C16.42 30.9124 15.2866 29.1699 15.2866 27.5691C15.2866 26.9883 15.7541 26.5208 16.335 26.5208C16.9158 26.5208 17.3833 26.9883 17.3833 27.5691C17.3833 28.3341 18.0208 29.3258 18.7291 29.6374L28.2775 33.8874C28.7308 34.0858 29.255 34.0858 29.7083 33.8874L39.2566 29.6374C39.965 29.3258 40.6025 28.3483 40.6025 27.5691C40.6025 26.9883 41.07 26.5208 41.6508 26.5208C42.2316 26.5208 42.6991 26.9883 42.6991 27.5691C42.6991 29.1558 41.5658 30.9124 40.1066 31.5641L30.5583 35.8141C30.0766 36.0266 29.5383 36.1399 29 36.1399Z",
    fill: "url(#paint1_linear_1403_2784)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29 43.1668C28.4616 43.1668 27.9233 43.0534 27.4275 42.8409L17.8791 38.5909C16.3066 37.8968 15.2866 36.3243 15.2866 34.5959C15.2866 34.0151 15.7541 33.5476 16.335 33.5476C16.9158 33.5476 17.3833 34.0151 17.3833 34.5959C17.3833 35.4884 17.9075 36.2959 18.7291 36.6643L28.2775 40.9143C28.7308 41.1126 29.255 41.1126 29.7083 40.9143L39.2566 36.6643C40.0641 36.3101 40.6025 35.4884 40.6025 34.5959C40.6025 34.0151 41.07 33.5476 41.6508 33.5476C42.2316 33.5476 42.6991 34.0151 42.6991 34.5959C42.6991 36.3243 41.6791 37.8826 40.1066 38.5909L30.5583 42.8409C30.0766 43.0534 29.5383 43.1668 29 43.1668Z",
    fill: "url(#paint2_linear_1403_2784)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 57.5,
    height: 57.5,
    rx: 4.75,
    stroke: "#2A85FF",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1403_2784",
    x1: 22.6879,
    y1: 17.0309,
    x2: 42.3944,
    y2: 37.9246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1403_2784",
    x1: 22.2597,
    y1: 28.0367,
    x2: 34.3099,
    y2: 47.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1403_2784",
    x1: 22.2597,
    y1: 35.0636,
    x2: 34.3099,
    y2: 54.8839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrototyping);
export default __webpack_public_path__ + "static/media/prototyping.6551e8d563b1b655f0f675df0aa147ac.svg";
export { ForwardRef as ReactComponent };